import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryPackage4UpImagesIntegrityProps {
    items?: CuratedItem[] | [];
}

export default function integrityCheck({
    items,
}: StoryPackage4UpImagesIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["image"]);
}
